export * from './datei-arts.service';
export * from './datei-arts.service.module';